import { topliApi } from '@/shared/api/topli/TopliApi'
import { useQuery } from '@tanstack/react-query'
import { LandingLogParams } from '../model'

export const landingNotificationLogQueryKey = 'landingNotificationLog'
export const landingViewsQueryKey = 'landingViews'

export const fetchLandingNotificationLog = async ({ limit, offset, sort, user_id, events }) => {
  const requestParams: LandingLogParams = {
    limit,
    offset,
    sort,
    user_id,
  }

  if (events?.length) {
    requestParams.form_type__in = events
  }

  const response = await topliApi.landing.list(requestParams)
  return response
}
export const useLandingNotificationLog = ({ sort, limit, offset, user_id, events }) =>
  useQuery({
    queryKey: [landingNotificationLogQueryKey, sort, offset, limit, user_id, events],
    queryFn: () => fetchLandingNotificationLog({ sort, limit, offset, user_id, events }),
  })

export const fetchLandingViews = async (ldId: number) => {
  const response = await topliApi.landing.getViews(ldId)
  return response
}

export const useLandingViews = (ldId: number) =>
  useQuery({
    queryKey: [landingViewsQueryKey, ldId],
    queryFn: () => fetchLandingViews(ldId),
  })
